export default {
    OC: "Mock Test Report",
    OCHome: "Comments page", 
    PC:"Personal Center",
    BILL:"My bill",
    RUlE:"Distributive Rules"
}


// WEBPACK FOOTER //
// ./src/i18n/en-US/menu.js